/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getAllUniversityStates, getUniversityListPagination, manageUniversities, resetUniversity, resetUniversityList } from '../actions/masterManagementAction';
import masterLabels from '../labels/master_en.json';
import commonLabels from '../../../common/labels/common_en.json';
import TablePagination from '../../../common/components/TablePagination';
import ConfirmationDialog from '../../../common/components/ConfirmationDialog';
import UniversityForm from './UniversityForm';
import { toastr } from 'react-redux-toastr';
import Select from 'react-select';


const UniversityList = () => {
  let rowPerPage = 10;
  const dispatch = useDispatch();
  let [addUniversity, setAddUniversity] = useState({ "Mode": false, "universityState": '', "qualificationNameCode": '', "universityCode": '', "universityName": '' });
  let [searchMode, setSearchMode] = useState(false);
  let [universityCode, setUniversityCode] = useState('');
  let [universityName, setUniversityName] = useState('');
  let [universityState, setUniversityState] = useState('');
  let [qualificationNameCode, setQualificationNameCode] = useState('');
  let [listCurrentPage, setListCurrentPage] = useState(0);
  let [showModal, setShowModal] = useState(false);
  let [deleteUniversity, setDeleteUniversity] = useState(0);

  useEffect(() => {
    dispatch(getAllUniversityStates());
    dispatch(resetUniversity());
    dispatch(resetUniversityList());
    setUniversityName('');
    // eslint-disable-next-line
  }, [])



  const inputRef = useRef();

  const onUniversityStateChange = (e) => {
    dispatch(resetUniversity());
    dispatch(resetUniversityList());

    setUniversityName('');
    universityStateChange(e);
  }

  const universityStateChange = (e) => {
    let universitySelectedState = e.target.value;
    let universityNameTemp = '';
    setUniversityState(universitySelectedState);

   universitySelectedState &&  dispatch(getUniversityListPagination(0, rowPerPage, universitySelectedState, universityNameTemp, qualificationNameCode));
  }

  const searchData = (textToSearch) => {
    setSearchMode(Number(new Date()));
    universityState && dispatch(getUniversityListPagination(0, rowPerPage, universityState, textToSearch, qualificationNameCode));
    (!universityState) && toastr.error(commonLabels.SEARCH_VALIDATION_ERROR);
  }

  const { universityStates, universitiesList, universityPageNoCounter } = useSelector((state) => state.masterManagementReducer, shallowEqual);
  let tableCounter = universityPageNoCounter + 1;

  const manageUniversity = (id) => {
    setShowModal(true);
    setDeleteUniversity(id);
  }

  const deleteUniversityData = (id) => {
    setShowModal(false);
    let requestBody = {
      "universityDto":
      {
        "universityCode": id,
        "isDeleted": true
      }
    };
    dispatch(manageUniversities(requestBody, rowPerPage, listCurrentPage, universityState, universityName, qualificationNameCode));
  }

  const activeUniversity = (id, isActive) => {
    let requestBody = { "universityDto": { "universityCode": id, "isActive": !isActive } };
    dispatch(manageUniversities(requestBody, rowPerPage, listCurrentPage, universityState, universityName, qualificationNameCode));
  }
  return addUniversity.Mode != false ? (
    <div>
      <UniversityForm
        addUniversity={addUniversity}
        setAddUniversity={setAddUniversity}
        setUniversityState={setUniversityState}
        universityCode={universityCode}
        universityName={universityName}
        universityState={universityState}
        qualificationNameCode={qualificationNameCode}
        setQualificationNameCode={setQualificationNameCode}
        setUniversityCode={setUniversityCode}
        setUniversityName={setUniversityName}
      />
    </div>
  ) : (
    <div className="border border-light" style={{ width: "100%", padding: "20px" }}>
      <div className='form-group'>
        <div className='row'>
          <div className='col-md-2 mt-2 '>
            <label className="font-weight-bold float-left">{masterLabels.universityList.States}<span className="redColor">*</span></label>
            {/* <select
              className='form-select '
              name="universityState"
              onInput={onUniversityStateChange}
              ref={inputRef}
              defaultValue={addUniversity && addUniversity.universityState}
            >
              <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
              {universityStates && universityStates && universityStates.length > 0 && universityStates.map((element, index) =>
                <option key={index} value={element.code}>{element.name}</option>
              )}
            </select> */}

<br />
<Select
  // className="form-select"
  name="universityState"
  options={
    universityStates?.map(el => ({
      value: el.code,
      label: el.name
    })) || []
  }
  onChange={selectedOption => {
    onUniversityStateChange({
      target: {
        name: 'universityState',
        value: selectedOption?.value || ''
      }
    });
  }}
  value={
    universityStates
      ?.map(el => ({
        value: el.code,
        label: el.name
      }))
      .find(option => option.value === (addUniversity?.universityState || universityState)) || null
  }
  placeholder={commonLabels.COMBO_SELECT}
  isClearable
  ref={inputRef}
/>

          </div>

          <div className='col-md-3 mt-4'>
            <input
              type="text"
              className="form-control mt-2"
              name="universityName"
              value={universityName}
              placeholder={masterLabels.universityList.Search_Label}
              onChange={event => { setUniversityName(event.target.value); setSearchMode(false); }}
              maxLength="50"
            />
          </div>
          <div className='col-md-1  mt-4'>
            <button className='form-control mt-2 btn-primary button_search' onClick={() => { searchData(universityName); }}><i className="fa fa-search" type="button" ></i></button>
          </div>
          <div className='col-md-1'></div>
          <div className='col-md-2 text-right mt-4'>
            <button className=' btn form-control btn-primary custom_button' onClick={() => { setUniversityName(''); setAddUniversity({ "Mode": "Add" }) }}>
              {masterLabels.universityList.Add_University}
            </button>
          </div>
        </div>
      </div>
      <br />
      <div className='form-group'>
        {universitiesList && universitiesList.totalNumberOfRecords > 0 ?
          <div className='row'>
            <div className='col-md-12'>
              <table className="table table-bordered">
                <thead className="thead-light">
                  <tr>
                    {/* <th scope="col" className='w-10 text-center'>{masterLabels.universityList.No}</th> */}
                    <th scope="col" className='w-10 text-center'>{masterLabels.universityList.University_Code}</th>
                    <th scope="col" className='w-40 text-left'>{masterLabels.universityList.University_Name}</th>
                    <th scope="col" className='w-40 text-left'>{masterLabels.universityList.Qualification_Name_Code}</th>
                    <th scope="col" className='w-10 text-center'>{masterLabels.universityList.Action}</th>
                  </tr>
                </thead>
                <tbody className='small'>

                  {universitiesList && universitiesList.universityDtoList && universitiesList.universityDtoList.map((element, index) => {
                    if (element) {
                      return (
                        <tr key={index}>
                          {/* <td className="w-10 word-break text-center">{tableCounter++}</td> */}
                          <td className="w-10 word-break text-center">{element.universityCode}</td>
                          <td className="text-left">{element.universityName}</td>
                          <td className="text-center">{(element.qualificationNameCode) ? element.qualificationNameCode : "-"}</td>
                          <td className="w-10 word-break text-center">
                            <i role="button" data-toggle="tooltip" title={commonLabels.BUTTON_EDIT} className='text-primary fa fa-edit' onClick={() => { setAddUniversity({ "Mode": "Edit", "universitycode": element.universityCode, "universityState": element.stateCode, "universityName": element.universityName }); }}></i>
                            &nbsp;&nbsp;
                            <i role="button" data-toggle="tooltip" title={element.isActive ? commonLabels.BUTTON_INACTIVE : commonLabels.BUTTON_ACTIVE}
                              className={element.isActive === true ? "text-success fa fa-toggle-on" : "text-danger fa fa-toggle-off"} onClick={(e) => { activeUniversity(element.universityCode, element.isActive); }}></i>
                            &nbsp;&nbsp;
                            <i role="button" data-toggle="tooltip" title={commonLabels.BUTTON_DELETE} className='text-danger fa fa-trash' onClick={(e) => { manageUniversity(element.universityCode); }}></i>
                          </td>
                        </tr>
                      )
                    }
                  })
                  }
                </tbody>
              </table>
              {universitiesList && universityState &&
                <TablePagination
                  paginationFor="university_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  searchCode2={universityState}
                  searchCode3={qualificationNameCode}
                  textToSearch={universityName}
                  searchMode={searchMode}
                  totalCount={universitiesList.totalNumberOfRecords}
                />
              }
            </div></div>
          :
          <div className='text-center'>
            <font className="text-danger">
              {universityState && commonLabels.NO_DATA_FOUND}
              {!universityState && masterLabels.universityList.Select_State_To_Fetch_Result}
            </font>
          </div>}
      </div>

      {
        <ConfirmationDialog
          showModal={showModal}
          Title={commonLabels.CONFIRMATION_MODAL_TITLE}
          Message={commonLabels.CONFIRMATION_MESSAGE}
          setShowModal={setShowModal}
          deleteRecord={deleteUniversityData}
          deletedId={deleteUniversity}
          IsConfirmation={"true"}
        />
      }
    </div>
  );
}

export default UniversityList;